var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"article"},[_c('b-row',[_c('b-col',[_c('b-card',{attrs:{"no-body":""}},[_c('puls-card-header',{attrs:{"title":_vm.article.title,"left-action":{
              to: {
                name: 'Section',
                title: _vm.sectionTitle,
                params: { section: _vm.sectionName }
              }
            }}}),_c('b-card-body',[_c('markdown-it-vue',{attrs:{"content":_vm.article.body}}),(_vm.article.iframe)?_c('iframe',{staticStyle:{"height":"800px","border":"0px"},attrs:{"src":_vm.article.iframe,"width":"100%","height":"100%"}}):_vm._e()],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }